import { render, staticRenderFns } from "./studentProjects.vue?vue&type=template&id=4b2e32e3&scoped=true"
import script from "./studentProjects.vue?vue&type=script&lang=js"
export * from "./studentProjects.vue?vue&type=script&lang=js"
import style0 from "./studentProjects.vue?vue&type=style&index=0&id=4b2e32e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e32e3",
  null
  
)

export default component.exports